import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const NSUD_REGISTRY_URL = `${SERVER_API}/nsud/reestr-kmns/actualizations/histories`;

export const NSUD_REGISTRY_ENDPOINTS = {
  LIST: {
    method: 'GET',
    url: `${NSUD_REGISTRY_URL}`,
  } as IEndpointData,
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${NSUD_REGISTRY_URL}/${id.toString()}`,
    };
  },
};
